import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/sections/HeroSection';
import LeaderboardSection from '../components/sections/LeaderboardSection';
import WhatItIsSection from '../components/sections/WhatItIsSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import SideQuestsSection from '../components/sections/SideQuestsSection';
import PartnersSection from '../components/sections/PartnersSection';
import PayoutModelSection from '../components/sections/PayoutModelSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import SubmitSection from '../components/sections/SubmitSection';
import FAQSection from '../components/sections/FAQSection';
import ArcadeNav from '../components/ArcadeNav';
import ArcadeFooter from '../components/ArcadeFooter';
import ArcadeCursor from '../components/ArcadeCursor';
import ScrollProgress from '../components/ScrollProgress';
import SoundToggle from '../components/SoundToggle';
import ArcadeMascot from '../components/ArcadeMascot';
import { SoundProvider } from '../context/SoundContext';

const HumanDataCashCup = () => {
  return (
    <SoundProvider>
      <div className="relative min-h-screen overflow-hidden">
        {/* Custom Arcade Cursor */}
        <ArcadeCursor />

        {/* Scroll Progress & Sound Toggle */}
        <ScrollProgress />
        <SoundToggle />
        <ArcadeMascot />

        {/* Scanline overlay effect */}
        <div className="scanline-overlay" />

        {/* Floating pixel decorations */}
        <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
          <motion.div
            className="absolute top-20 left-10 w-4 h-4 bg-neon-pink opacity-30"
            animate={{ y: [0, -20, 0], opacity: [0.3, 0.6, 0.3] }}
            transition={{ duration: 3, repeat: Infinity }}
          />
          <motion.div
            className="absolute top-40 right-20 w-3 h-3 bg-trophy-gold opacity-30"
            animate={{ y: [0, -15, 0], opacity: [0.3, 0.5, 0.3] }}
            transition={{ duration: 2.5, repeat: Infinity, delay: 0.5 }}
          />
          <motion.div
            className="absolute top-60 left-1/4 w-2 h-2 bg-success-green opacity-30"
            animate={{ y: [0, -10, 0], opacity: [0.3, 0.7, 0.3] }}
            transition={{ duration: 2, repeat: Infinity, delay: 1 }}
          />
        </div>

        {/* Navigation */}
        <ArcadeNav />

        {/* Main Content */}
        <main className="relative z-10">
          <HeroSection />
          <LeaderboardSection />
          <WhatItIsSection />
          <HowItWorksSection />
          <SideQuestsSection />
          <PartnersSection />
          <PayoutModelSection />
          <TestimonialsSection />
          <SubmitSection />
          <FAQSection />
        </main>

        {/* Footer */}
        <ArcadeFooter />
      </div>
    </SoundProvider>
  );
};

export default HumanDataCashCup;
